import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from './accordion.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AccordionComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    AccordionComponent
  ]
})
export class AccordionModule { }
